import { Refresh } from "iconsax-reactjs";
import type { ExportProgressStage } from "../../services/webServices/export/types";

interface ExportProgressModalProps {
  open: boolean;
  stage: ExportProgressStage;
  message: string;
}
 
export default function ExportProgressModal({
  open,
  stage,
  message,
}: ExportProgressModalProps) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[1200] flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm"
      dir="rtl"
    >
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-lg">
        <div className="mb-5 flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-full bg-primaryVar-50">
            <Refresh
              size={22}
              variant="Outline"
              color="var(--color-primary-500)"
              className="animate-spin"
            />
          </div>
          <div>
            <h2 className="text-lg font-bold text-gray-800">در حال تهیه خروجی</h2>
            <p className="mt-1 text-sm text-gray-500">
              لطفاً تا پایان فرآیند صبر کنید
            </p>
          </div>
        </div>

        <p className="mb-5 rounded-xl bg-gray-50 px-4 py-3 text-sm text-gray-700">
          {message}
        </p>

        
      </div>
    </div>
  );
}
